exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".onboard-email-container{margin-top:40px}.onboard-email-container .email-link{border:1px solid #F5821F;padding:7px;border-radius:5px;font-size:14px;color:#F5821F}.onboard-email-container h6{font-size:14px;color:#555;padding-bottom:5px}\n", ""]);

